export default "__VITE_ASSET__2084d3b0__"